import "data-layer-helper/dist/data-layer-helper";
import getWebAnalyticsContainer from "../../datalayer/analytics-container";

export default class DataProcessingService {
	constructor(service) {
		const { name, stage, mandanten, pagetypes, excludedPagetypes, serviceSettings, samplingCookie } = service;
		this.name = name;
		this.stage = stage;
		this.mandanten = mandanten;
		this.pagetypes = pagetypes;
		this.excludedPagetypes = excludedPagetypes;
		this.serviceSettings = serviceSettings;
		this.samplingCookie = samplingCookie;
		this.datalayer = getWebAnalyticsContainer();
		this.datalayerModel = new DataLayerHelper(this.datalayer);
	}

	get validEnvironment() {
		const validStage = this.isActiveForStage();
		const validMandant = this.isActiveForMandant();
		const validPagetype = this.isValidPagetype();
		if (validStage && validMandant && validPagetype) {
			return true;
		}
		return false;
	}

	isActiveForStage() {
		if(!this.stage) {
			return true;
		}
		const stage = this.datalayerModel.get("stage");
		return this.stage === "all" || this.stage === stage;
	}

	isActiveForMandant() {
		if(!this.mandanten) {
			return true;
		}

		this.mandantId = this.datalayerModel.get("mandant_id");
		if (!this.mandantId) {
			return false;
		}
		return this.mandanten.indexOf(this.mandantId.toString()) !== -1;
	}

	isValidPagetype() {
		const pagetype = this.datalayerModel.get("seitentyp");
		if(this.excludedPagetypes && this.excludedPagetypes.indexOf(pagetype) !== -1) {
			return false;
		}
		if(!this.pagetypes) {
			return true;
		}
		return this.pagetypes === "all" || this.pagetypes.indexOf(pagetype) !== -1;
	}

	/**
	 * Prüft, ob der Nutzer anhand des konfigurierten Sampling-Cookies in die Stichprobe des Services fällt.
	 * Ohne `samplingCookie`-Konfiguration ist die Prüfung bestanden; fehlt das Cookie oder ist der Wert
	 * keine Zahl, ist sie nicht bestanden.
	 *
	 * @returns {Promise<boolean>} true wenn der Cookie-Wert kleiner oder gleich `maxValue` ist
	 */
	async getValidSampling() {
		if (typeof(this.samplingCookie) === "undefined") {
			return true;
		}
		const { name, maxValue } = this.samplingCookie;
		const cookie = await cookieStore.get(name);
		const samplingCookieValue = cookie?.value;
		if (!samplingCookieValue) {
			return false;
		}
		const samplingValue = parseInt(samplingCookieValue, 10);
		if (isNaN(samplingValue)) {
			return false;
		}
		return samplingValue <= maxValue;
	}
}
